import React, { Component } from "react";
import AntdSkeleton, {SkeletonProps} from 'antd/lib/skeleton';
import 'antd/lib/skeleton/style';

export default class Skeleton extends Component<SkeletonProps> {
    render() {
        return (
          <AntdSkeleton {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/skeleton/index.tsx